import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement("div", rest, children);
};

ModalBody.displayName = 'Modal.Body';
ModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
ModalBody.defaultProps = {
  children: null,
  className: 'tg-modal-body'
};
export default ModalBody;